import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app-page flex-col"
};
import { remove } from '@/api/system/post';
import { isOnlyOne } from '@/utils/common';
import { deleteBox, toast } from '@/utils/message';
import { renderAddForm } from './add';
import { renderEditForm } from './edit';
import { searchForm } from './searchForm';
import { createTable } from './table';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Post',
  setup(__props) {
    const headerRef = ref();
    const tableRef = ref();
    const editFormRef = ref();
    const addFormRef = ref();
    let table = null;
    let search = null;
    let addForm = null;
    let editForm = null;
    onMounted(() => {
      search = searchForm(headerRef.value);
      table = createTable(tableRef.value, {
        rowEdit,
        rowDelete
      }, {
        addFn,
        editFn,
        deleteFn
      });
      editForm = renderEditForm(editFormRef.value);
      addForm = renderAddForm(addFormRef.value);
      table.load();
      addForm.onSaveSuccess = () => {
        table?.load(search?.getFormDataNotValidate());
      };
      editForm.onSaveSuccess = () => {
        table?.load(search?.getFormDataNotValidate());
      };
      search.onSearch = data => {
        table?.load(data);
      };
      search.onReset = () => {
        table?.load();
      };
    });
    function rowEdit(row) {
      editForm?.open(row.id);
    }
    function rowDelete(row) {
      deleteBox().then(() => {
        deleteReq([row.id]);
      });
    }
    /**
     * 表格头部添加
     */
    function addFn() {
      addForm?.open();
    }
    /**
     * 表格头部编辑
     * @param selects
     */
    function editFn(selects) {
      if (isOnlyOne(selects)) {
        editForm?.open(selects[0].id);
      }
    }
    /**
     * 表格头部批量删除
     * @param selects
     */
    function deleteFn(selects) {
      deleteBox().then(() => {
        deleteReq(selects.map(item => item.id));
      });
    }
    /**
     * 删除请求
     */
    function deleteReq(ids) {
      remove(ids).then(() => {
        toast.success('删除成功');
        table?.load(search?.getFormDataNotValidate(), false);
      });
    }
    return (_ctx, _cache) => {
      const _component_XFlexCtx = _resolveComponent("XFlexCtx");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "header",
        ref_key: "headerRef",
        ref: headerRef
      }, null, 512), _createVNode(_component_XFlexCtx, {
        flex: 1
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "table table-content",
          ref_key: "tableRef",
          ref: tableRef
        }, null, 512)]),
        _: 1
      }), _createElementVNode("div", {
        ref_key: "editFormRef",
        ref: editFormRef
      }, null, 512), _createElementVNode("div", {
        ref_key: "addFormRef",
        ref: addFormRef
      }, null, 512)]);
    };
  }
});